<template>
    <div
        class="personal-goal"
        @click="viewPersonalGoal">
        <div :class="['progress-bar', teacherAccess && personalGoalIn.badges.length === 0 ? 'full-width' : null]">
            <b-progress
                :value="personalGoalIn.tasks ? getProgressValue() : 0"
                :max="personalGoalIn.tasks ? personalGoalIn.tasks.length : 100"
                variant="success"
                show-progress
                animated>
            </b-progress>
        </div>

        <design-2021-personal-goal-archived-context-menu-component
            :teacher-access="teacherAccess"
            @unarchive-personal-goal="unArchivePersonalGoal"
            @remove-personal-goal="removePersonalGoal">
        </design-2021-personal-goal-archived-context-menu-component>

        <div class="title-and-skills">
            <div class="title">
                {{ personalGoalIn.name }}
                <div class="personal-goal-task-notice muted-text">
                    {{ getPersonalGoalTasksStatus() }}
                </div>
            </div>

            <div
                class="skills"
                v-if="personalGoalIn.skills.length > 0">
                <b-badge
                    class="skill-badge"
                    v-for="skill of personalGoalIn.skills"
                    variant="info"
                    :key="`${personalGoalIn.id}${skill.id}`">
                    {{ skill.name }}
                </b-badge>
            </div>
        </div>

        <div
            class="badge-earned"
            v-if="personalGoalIn.badges.length > 0">
            <img
                class="badge-image"
                :src="personalGoalIn.badges[0].file.public_path"
                alt="Badge" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-personal-goal-archived-component.vue',
    props: {
        personalGoalIn: {
            type: Object,
            required: true,
            default: () => {},
        },
        teacherAccess: {
            type: Number,
            required: false,
            default: 0,
        },
        skillTreesIn: {
            type: Array,
            required: true,
            default: () => [],
        },
    },

    methods: {
        getProgressValue() {
            const stats = this.personalGoalIn.getPersonalGoalTasksStatuses();
            return stats.finished;
        },

        getPersonalGoalTasksStatus() {
            let status = '';
            const stats = this.personalGoalIn.getPersonalGoalTasksStatuses();

            if (stats.finished === 0 && stats.unfinished === 0) {
                status = this.$t('personal_goals.this_learning_goal_has_no_tasks');
            } else if (stats.finished === this.personalGoalIn.tasks.length) {
                status = this.$t('personal_goals.all_tasks_completed');
            } else if (stats.finished > 0) {
                status = `${stats.finished} van de ${this.personalGoalIn.tasks.length} taken voltooid`;
            } else {
                status = this.$t('personal_goals.no_tasks_completed');
            }
            return status;
        },

        addPersonalGoalsTask() {
            this.$refs['add-personal-goal-task'].show(this.personalGoalIn);
        },

        editPersonalGoal() {
            this.$refs['edit-personal-goal'].show();
        },

        unArchivePersonalGoal() {
            this.alert.saving();

            this.axios.post(this.routes.personalGoalUnArchive(this.personalGoalIn.id)).then(
                (response) => {
                    this.personalGoalIn.update({ archived: 0 });
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        viewPersonalGoal() {
            this.$emit('personal-goal-overview', this.personalGoalIn);
        },

        removePersonalGoal() {
            this.alert
                .confirm(
                    this.$t('common.delete_learning_goal'),
                    this.$t('personal_goals.are_you_sure_you_want_to_delete_this_learning_goal'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();
                    this.axios.delete(this.routes.personalGoalRemove(this.personalGoalIn.id)).then(
                        (response) => {
                            this.personalGoalIn.remove();
                            this.alert.success();
                        },
                        (error) => {
                            return this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped lang="scss">
.personal-goal {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin: 19px -20px 15px -20px;
    padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'twenty-one');

    &:after {
        content: '';
        position: absolute;
        display: block;
        bottom: -10px;
        height: 1px;
        left: 0;
        width: 100%;
        background-color: $border-color;
    }

    &:hover {
        cursor: pointer;
        background-color: $secondary-background-color;
        border-color: $white;
        border-radius: $border-radius-content;
    }

    &:nth-child(even) {
        background-color: $secondary-background-color;

        &:hover {
            background-color: darken($secondary-background-color, 10%);
        }
    }
}

.progress-bar {
    width: calc(100% - 55px);
    margin-right: auto;

    &.full-width {
        width: 100%;
    }
}

.title-and-skills {
    width: 100%;
}

.title {
    font-weight: $font-weight-bold;
    font-size: $base-font-size;
}

.personal-goal-task-notice {
    font-size: $default-font-size;
    font-weight: $font-weight-medium;
}

.skills {
    flex: 1 0 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: map-get($grid-gutter-spacing, 'ten');
    row-gap: map-get($grid-gutter-spacing, 'ten');
    margin-top: map-get($grid-gutter-spacing, 'five');
}

.skill-badge {
    font-size: 0.6875rem;
}

.badge-earned {
    width: 75px;
    height: 75px;
    flex: 0 0 auto;
    align-self: baseline;
    margin-top: map-get($grid-gutter-spacing, 'ten');
    margin-left: auto;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .title-and-skills {
        width: calc(100% - 105px);
        margin-left: 0;
    }
}
</style>
